/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PracticeListItemDto } from './PracticeListItemDto';
import {
    PracticeListItemDtoFromJSON,
    PracticeListItemDtoFromJSONTyped,
    PracticeListItemDtoToJSON,
    PracticeListItemDtoToJSONTyped,
} from './PracticeListItemDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface PracticeListResponseDto
 */
export interface PracticeListResponseDto {
    /**
     * List of practices
     * @type {Array<PracticeListItemDto>}
     * @memberof PracticeListResponseDto
     */
    practices: Array<PracticeListItemDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof PracticeListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the PracticeListResponseDto interface.
 */
export function instanceOfPracticeListResponseDto(value: object): value is PracticeListResponseDto {
    if (!('practices' in value) || value['practices'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PracticeListResponseDtoFromJSON(json: any): PracticeListResponseDto {
    return PracticeListResponseDtoFromJSONTyped(json, false);
}

export function PracticeListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PracticeListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'practices': ((json['practices'] as Array<any>).map(PracticeListItemDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function PracticeListResponseDtoToJSON(json: any): PracticeListResponseDto {
    return PracticeListResponseDtoToJSONTyped(json, false);
}

export function PracticeListResponseDtoToJSONTyped(value?: PracticeListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'practices': ((value['practices'] as Array<any>).map(PracticeListItemDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

